import React, { useState, useEffect } from 'react';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

function PaypalPayment({ onButtonClick }) {
  const [paidFor, setPaidFor] = useState(false);
  const [error, setError] = useState(null);
 
  const handleApprove = async (orderId) => {
    try {
      // Simulate a backend call to fulfill the order
      // Example Axios request
      // const response = await axios.post('/api/fulfillOrder', { orderId });

      // If the backend call is successful
      setPaidFor(true);
      
    } catch (err) {
      // Handle error
      setError('An error occurred while processing the order.');
      console.error('Error fulfilling order:', err);
    }
  };

  // Call onButtonClick only if paidFor is true and it hasn't been called yet
  useEffect(() => {
    if (paidFor) {
      onButtonClick();
 
    }
  }, [paidFor, onButtonClick]);

  if (error) {
    alert(error);
  }

  const initialOptions = {
    clientId: "AWUxpJBlSe7sQl_LnCJPe5FzlscBH1r-EU75CNlUJFKDKomUBKXdIYdVZd0fy7oafVstnbLBWoSpu56G",
    currency: "USD",
    intent: "capture",
  };

  return (
    <div className='mt-2'>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons 
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  description: 'Order from website',
                  amount: {
                    value: '23' // Replace with dynamic value if needed
                  }
                }
              ]
            });
          }}
          onApprove={async (data, actions) => {
            const order = await actions.order.capture();
            console.log("order", order);
            handleApprove(data.orderID);
          }}
          onError={(err) => {
            setError(err.message || 'An unexpected error occurred.');
            console.error("PayPal Checkout onError", err);
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
}

export default PaypalPayment;
